import { render } from "./ReminderResultMessageListPage.vue?vue&type=template&id=12958942&scoped=true"
import script from "./ReminderResultMessageListPage.vue?vue&type=script&lang=js"
export * from "./ReminderResultMessageListPage.vue?vue&type=script&lang=js"

import "./ReminderResultMessageListPage.vue?vue&type=style&index=0&id=12958942&scoped=true&lang=css"
import "./ReminderResultMessageListPage.vue?vue&type=style&index=1&id=12958942&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12958942"]])

export default __exports__